import { Box } from '@mui/material';
import { AppContextMenu } from '@/UI/AppContextMenu/AppContextMenu';
import { AddNodeMenu } from './AddNodeMenuContent';
import type { AddNewNodeOptions } from '../flowTypes';
import type { Connection } from '../FlowComponents/FlowTour/ConnectionContext';

interface AddNodeFloatMenuProps {
  positionX: number;
  positionY: number;
  isOpen: boolean;
  connection?: Connection;
  addNewNode: ({ action, dropX, dropY, connection }: AddNewNodeOptions) => void;
  onClose: () => void;
}

/**
 * Floating menu for adding nodes to the canvas
 * Appears when right-clicking on the canvas or dragging from a connection handle
 */
function AddNodeFloatMenu({ positionX, positionY, isOpen, addNewNode, onClose, connection }: AddNodeFloatMenuProps) {
  return (
    <Box>
      <AppContextMenu
        open={isOpen}
        onClose={onClose}
        mouseX={positionX}
        mouseY={positionY}
        maxHeight="580px"
        onKeyDown={(event) => {
          // Disable native arrow key navigation
          if (['ArrowUp', 'ArrowDown'].includes(event.key)) {
            event.preventDefault();
          }
        }}
        width="180px"
      >
        <AddNodeMenu
          positionX={positionX}
          positionY={positionY}
          addNewNode={addNewNode}
          onClose={onClose}
          connection={connection}
          autoFocus={isOpen}
        />
      </AppContextMenu>
    </Box>
  );
}

export default AddNodeFloatMenu;
